import React from "react"
import AgendaItem from "./AgendaItem"

import styles from "./program.module.scss"

const Program = ({ content }) => {
  return (
    <div className={styles.program}>
      <h6 className={styles.programOverline}>{content.date}</h6>
      <h3 className={styles.programDay}>
        {content.day}{" "}
        <div className={styles.programDayTheme}>{content.theme}</div>
      </h3>
      <div className={styles.programAgenda}>
        {content.agenda.map((agenda, i) => {
          return <AgendaItem key={i} content={agenda} />
        })}
      </div>
    </div>
  )
}

export default Program
